export default __webpack_public_path__ + "static/media/1.3e31e752.jpg";